/**
 * Paleta de Design — Prodgy
 * Identidade visual consolidada para toda a aplicação
 */

// 🔵 Azul Prodgy (Brand / AI / Destaque)
export const PRODGY_BRAND = {
  primary: '#0B6FC2',   // Azul Primária - CTAs estratégicos, destaques de IA
  secondary: '#0A4A73', // Azul Secundária - Estados ativos
  tertiary: '#56B0F0',  // Azul Terciária - Links e foco
  info: '#3498DB',      // Info - Informações adicionais
} as const;

// 🖤 Preto Funcional (Action / Neutral Power)
export const PRODGY_ACTION = {
  primary: '#0A0A0A',   // Preto Prodgy - Botões primários neutros, ações críticas
  pure: '#000000',      // Preto puro - Contextos flat
} as const;

// ⚫ Dark UI (Base da aplicação)
export const PRODGY_DARK = {
  background: '#0E141B',    // Background principal
  surface: '#16202A',       // Superfícies / Cards
  border: '#1F2A36',        // Dividers / Borders
  textPrimary: '#F5F7FA',   // Texto primário
  textSecondary: '#B3C0CC', // Texto secundário
} as const;

// 🚦 Estados de Sistema (sem competir com marca)
export const PRODGY_STATUS = {
  success: '#2ECC71',  // Success
  warning: '#F1C40F',  // Warning
  error: '#E74C3C',    // Error
  info: '#3498DB',     // Info
} as const;

// 📊 Paleta para Gráficos (Array para ECharts)
export const PRODGY_CHART_COLORS = [
  PRODGY_BRAND.primary,
  PRODGY_BRAND.tertiary,
  PRODGY_BRAND.secondary,
  PRODGY_BRAND.info,
];

// 🎨 Paleta para Thresholds (Estados em gráficos)
export const PRODGY_THRESHOLD_COLORS = {
  good: PRODGY_STATUS.success,
  warning: PRODGY_STATUS.warning,
  danger: PRODGY_STATUS.error,
} as const;

// 🔧 Helper para obter cor com opacidade
export const withOpacity = (color: string, opacity: number): string => {
  const hex = color.replace('#', '');
  const alpha = Math.round(opacity * 255).toString(16).padStart(2, '0');
  return `#${hex}${alpha}`;
};
